module.exports = __webpack_public_path__ + "public/img/desain-logo-dan-konten-untuk-desainer-grafis.fafaface.png";